
export const InquiryClosedReasonEnum = {
    lookupTypeId : 3204  , 
    lookupItemName : 'InquiryClosedReason'

  };
  